/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section4_TitleInputs */

const en_about_section4_title = /** @type {(inputs: About_Section4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technology`)
};

const ko_about_section4_title = /** @type {(inputs: About_Section4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기술 스택`)
};

const ja_about_section4_title = /** @type {(inputs: About_Section4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技術スタック`)
};

/**
* | output |
* | --- |
* | "Technology" |
*
* @param {About_Section4_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section4_title = /** @type {((inputs?: About_Section4_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section4_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section4_title(inputs)
	if (locale === "ko") return ko_about_section4_title(inputs)
	return ja_about_section4_title(inputs)
});